import { useEffect, useState } from 'react'; // Import useEffect and useState
import { Link } from '~/components/ui/link';
import { Stack } from 'styled-system/jsx';

interface VersionPickerProps {
  id: string;
  versions: { hash: string; date: string; label?: string }[];
}

export function VersionPicker({ id, versions }: VersionPickerProps) {
  const [currentVersionFromUrl, setCurrentVersionFromUrl] = useState<string | undefined>(undefined); // Initialize with undefined
  const [currentQueryParams, setCurrentQueryParams] = useState<string>('');

  const [isCurrentVersionActive, setIsCurrentVersionActive] = useState(false);

  useEffect(() => {
    // This code runs only on the client side after the component mounts
    const currentPathParts = window.location.pathname.split('/');
    const version =
      currentPathParts.length >= 2
        ? currentPathParts[currentPathParts.length - 1]
        : versions[0]?.hash;
    setCurrentVersionFromUrl(version);
    setCurrentQueryParams(window.location.search);

    setIsCurrentVersionActive(window.location.pathname.split('/').filter(Boolean).join('/') === id);
  }, [versions, id]); // Re-run if versions or id change

  return (
    <Stack gap="2" direction="row" flexWrap="wrap">
      <Link
        href={`/${id}${currentQueryParams}`}
        style={{
          fontWeight: isCurrentVersionActive ? 'bold' : 'normal',
          textDecoration: isCurrentVersionActive ? 'underline' : 'none'
        }}
      >
        Current
      </Link>
      {versions.map((version) => (
        <Link
          key={version.hash}
          href={`/${id}/${version.hash}${currentQueryParams}`}
          style={{
            fontWeight: version.hash === currentVersionFromUrl ? 'bold' : 'normal',
            textDecoration: version.hash === currentVersionFromUrl ? 'underline' : 'none'
          }}
        >
          {`${version.date.split('T')[0]}`}
        </Link>
      ))}
    </Stack>
  );
}
